// 13/10/2026 — secretárias e motorista saem de "Auxiliares" e viram um grupo
// próprio. Valor interno `apoio`; na tela, sempre "Secretárias / motorista".
// `ambos` continua = veterinário E auxiliar (não inclui `apoio`).
// Regra do filtro (no backend, services/tipo-profissional.ts): veterinario →
// vet+ambos; auxiliar → aux+ambos; apoio → só apoio; todos → todo mundo.

export type TipoProfissional = "veterinario" | "auxiliar" | "ambos" | "apoio";
export type FiltroTipo = "todos" | "veterinario" | "auxiliar" | "apoio";

export const ROTULO_APOIO = "Secretárias / motorista";

/** Rótulo de UMA ficha (badge, select de tipo). */
export const ROTULO_TIPO: Record<TipoProfissional, string> = {
  veterinario: "Veterinário",
  auxiliar: "Auxiliar",
  ambos: "Vet + Auxiliar",
  apoio: ROTULO_APOIO,
};

/** Rótulo de GRUPO (filtros, contagens). */
export const ROTULO_TIPO_PLURAL: Record<TipoProfissional, string> = {
  veterinario: "Veterinários",
  auxiliar: "Auxiliares",
  ambos: "Vet + Auxiliar",
  apoio: ROTULO_APOIO,
};

export function ehTipoProfissional(v: string): v is TipoProfissional {
  return v === "veterinario" || v === "auxiliar" || v === "ambos" || v === "apoio";
}

/** Rótulo de um tipo vindo do banco como string; tipo desconhecido passa cru. */
export function rotuloTipo(tipo: string, plural = false): string {
  if (!ehTipoProfissional(tipo)) return tipo;
  return plural ? ROTULO_TIPO_PLURAL[tipo] : ROTULO_TIPO[tipo];
}
